<template>
  <div class="map-tools">
    <ul class="map-tools__list">
      <li
        @click="clickHandler(tool.id)"
        :class="`map-tools__item ${tool.id}`"
        v-for="tool in filteredTools"
        :key="tool.id"
      >
        <template v-if="tool.id === '3d'">
          <r-icon :name="is3d ? '3D' : tool.icon" :size="20" />
        </template>
        <template v-else-if="tool.id === 'reset'">
          <r-icon
            :style="`transform: rotateZ(${mapBearing}deg)`"
            :name="tool.icon"
            :size="20"
          />
        </template>
        <template v-else>
          <r-icon :name="tool.icon" :size="20" />
        </template>

        <div class="map-baselayers" v-if="tool.id === 'baselayers'">
          <div class="map-baselayers__title">Подложки</div>
          <ul class="map-baselayers__list">
            <li
              v-for="layer in baselayers"
              :key="layer.id"
              @click.stop="clickHandler(tool.id, layer)"
              :class="[
                baselayerId === layer.id ? 'active' : '',
                'map-baselayers__item'
              ]"
            >
              {{ layer.label }}
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
function dataURLtoBlob(dataurl) {
  const arr = dataurl.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new Blob([u8arr], { type: mime });
}

const allTools = [
  { id: "baselayers", icon: "layers-folder" },
  { id: "3d", icon: "2D" },
  { id: "reset", icon: "compass-north" },
  { id: "screenshot", icon: "download" }
];

export default {
  props: {
    tools: {
      type: Array,
      default: () => ["3d", "reset"]
    },
    map: {
      type: Object
    },
    baselayerId: {
      type: Number
    },
    is3d: {
      type: Boolean
    },
    mapBearing: {
      type: Number
    }
  },
  data() {
    return {
      baselayers: this.$store.state.map.baselayers
    };
  },
  computed: {
    filteredTools() {
      return allTools.filter(t => this.tools.includes(t.id));
    }
  },
  methods: {
    clickHandler(id, payload) {
      switch (id) {
        case "3d": {
          const pitch = this.is3d ? 0 : 60;
          this.map.easeTo({ pitch });
          this.$emit("change-prop", { field: "is3d", value: !this.is3d });

          return;
        }
        case "reset": {
          this.map.easeTo({ pitch: 0, bearing: 0 });
          this.$emit("change-prop", { field: "is3d", value: false });

          return;
        }
        case "baselayers": {
          if (!payload) return;
          if (this.baselayerId === payload.id) return;

          console.log(payload);

          this.$emit("toggle-base-layer", payload);

          return;
        }
        case "screenshot": {
          this.exportMap();
        }
      }
    },
    exportMap() {
      const base = this.map.getCanvas().toDataURL("image/png");
      const blob = dataURLtoBlob(base);
      const objectUrl = window.URL.createObjectURL(blob, { type: "image/png" });

      const link = document.createElement("a");
      link.setAttribute("download", "ritm-map.png");
      link.setAttribute("href", objectUrl);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style lang="scss" scoped>
.map-tools {
  position: absolute;
  top: 16px;
  right: 16px;
  border-radius: 4px;
  background-color: var(--modal_bg) !important;

  &__item {
    width: 36px;
    height: 36px;
    cursor: pointer;
    color: var(--text_primary) !important;

    &:first-child {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }

    &:last-child {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    &:hover {
      background-color: rgba(var(--accent_primary), 0.2);
    }

    &.baselayers {
      &:hover {
        .map-baselayers {
          display: block;
        }
      }
    }
  }
}

.map-baselayers {
  display: none;
  position: absolute;
  top: 0;
  right: calc(100% + 8px);
  border-radius: var(--border-radius);
  border: 1px solid transparent;
  padding: 5px 0;
  width: 175px;
  z-index: 1100;
  border-color: var(--dividers_low_contrast) !important;
  background-color: var(--modal_bg) !important;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.5);

  &:after {
    content: "";
    position: absolute;
    top: 0;
    right: -8px;
    width: 8px;
    height: 36px;
    display: block;
  }

  &__title {
    color: var(--text_primary) !important;
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 8px;
    margin-left: 8px;
  }

  &__item {
    cursor: pointer;
    padding: 8px 16px;
    font-size: 12px;
    color: var(--text_primary) !important;

    &:hover {
      background-color: rgba(var(--accent_primary), 0.2);
    }

    &.active {
      background-color: var(--accent_selected);
      color: var(--white_white) !important;
      font-weight: bold;
    }
  }
}
</style>
